import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import {
  DEFAULT_TITLE,
  staticMeta,
  staticMetaLoader,
} from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/oauth2.$applicationSlug.authorize'

const getClientModule = () =>
  import('src/clientRoutes/oauth2.$applicationSlug.authorize')

export const handle = { name: 'oauth2-authorize' }

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: DEFAULT_TITLE,
    description: t('server:meta.login.description'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
